
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Eye, Gavel } from "lucide-react";
import { Link } from "react-router-dom";
import BidSubmissionDialog from "./BidSubmissionDialog";
import { Investment } from "@/types/investment";
import InvestmentCardHeader from "./InvestmentCardHeader";
import OriginalContractTerms from "./OriginalContractTerms";
import CurrentInformation from "./CurrentInformation";
import InvestmentOpportunity from "./InvestmentOpportunity";
import BalloonPaymentAlert from "./BalloonPaymentAlert";

interface InvestmentCardProps {
  investment: Investment;
}

const InvestmentCard = ({ investment }: InvestmentCardProps) => {
  const [isBidDialogOpen, setIsBidDialogOpen] = useState(false);

  const handleSubmitBid = () => {
    setIsBidDialogOpen(true);
  };

  return (
    <>
      <Card className="hover:shadow-lg transition-shadow duration-300">
        <CardHeader>
          <InvestmentCardHeader investment={investment} />
        </CardHeader>
        
        <CardContent>
          {/* Two Column Layout */}
          <div className="grid md:grid-cols-2 gap-8 mb-6">
            <OriginalContractTerms investment={investment} />
            <CurrentInformation investment={investment} />
          </div>

          <Separator className="my-6" />

          <InvestmentOpportunity investment={investment} />
          <BalloonPaymentAlert investment={investment} />
          
          {/* Action Buttons */}
          <div className="flex justify-end space-x-2">
            <Link to={`/investment/${investment.id}`}>
              <Button variant="outline" size="sm">
                <Eye className="h-4 w-4 mr-1" />
                View Details
              </Button>
            </Link>
            {investment.status === "Open for Bidding" && (
              <Button size="sm" className="bg-yellow-800 hover:bg-yellow-900" onClick={handleSubmitBid}>
                <Gavel className="h-4 w-4 mr-1" />
                Submit Bid
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
      
      <BidSubmissionDialog 
        isOpen={isBidDialogOpen}
        onClose={() => setIsBidDialogOpen(false)}
        investmentId={investment.id}
      />
    </>
  );
};

export default InvestmentCard;
